import React from "react";
import "./AboutUsDivider.css";

const AboutUsDivider = (props) => {
  return (
    <section className="our-thinking-section">
      <header className="header-aboutus">
        <h2>{props.heading}</h2>
      </header>
    </section>
  );
};

export default AboutUsDivider;
